import { Link } from '@inertiajs/react'
import { track } from '../lib/events'

export default function EditionSwitcher({ editions, current, path }) {
  return (
    <div className="edsw">
      {editions.map((e) => (
        <Link
          key={e.slug}
          href={`/${e.slug}/${path}`}
          className={e.slug === current.slug ? 'on' : ''}
          onClick={() => e.slug !== current.slug && track('edition-switched', { edition: e.slug })}
        >
          {e.name}
          <span className="edsw-date"> · {e.date}</span>
        </Link>
      ))}
    </div>
  )
}
